// TODO: Need Audit
import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyTracker from 'shared/ahoy_tracker';

export default class GTMTracker {
  constructor(element) {
    this.element = element;
    this.data = element.dataset;
    this.ahoy = new AhoyTracker(element);
  }

  inViewPort(element) {
    if (  !element || (element.nodeType !== 1) || 
          VidioHelpers.getComputedStyle($(element).closest('.tab-pane')[0], 'display') === 'none') {
      return false;
    }
    var rect = element.getBoundingClientRect();
    var width = document.documentElement.clientWidth;
    var height = document.documentElement.clientHeight;

    return (!!rect && rect.bottom >= 0 && rect.top <= height && rect.right >= 0 && rect.left <= width);
  }

  init() {
    if(this.data.gtmImpression != undefined) {
      this.bindImpressionGtmTracker();
    }
    if(this.data.gtmClick != undefined) {
      this.bindClickGtmTracker();
    }
  }

  bindImpressionGtmTracker() {
    var parentNode = this.element.parentNode;
    var impressionSent = false;
    var sendImpression = () => {
      if(!impressionSent && this.inViewPort(this.element)) {
        var dt = {};
        if (this.data.gtmEvt) dt.event = this.data.gtmEvt;
        if (this.data.gtmName) dt.feature_name = this.data.gtmName;
        if (this.data.gtmLoc) dt.feature_location = this.data.gtmLoc;
        if (this.data.gtmType) dt.feature_type = this.data.gtmType;
        if (this.data.gtmPremierName) dt.premier_name = this.data.gtmPremierName;
        if (this.data.gtmPremierPrice) dt.premier_price = this.data.gtmPremierPrice;
        if (this.data.gtmPremierId) dt.premier_id = this.data.gtmPremierId;

        window.dataLayer.push(dt);
        impressionSent = true;

        this.ahoy.sendEventImpression();
      }
    };

    window.addEventListener('load', sendImpression);
    window.addEventListener('scroll', sendImpression);
    if(parentNode.scrollWidth > parentNode.clientWidth) {
      parentNode.addEventListener('scroll', sendImpression);
    }

    window.addEventListener('turbolinks:before-visit', function(){
      window.removeEventListener('scroll', sendImpression);
    });

  }

  bindClickGtmTracker() {
    var posX = 0;

    this.element.addEventListener('mousedown', function(event) {
      posX = event.clientX;
    }.bind(this));

    this.element.addEventListener('mouseup', function(event) {
      posX -= event.clientX || 0;
      if(posX == 0) {
        var dt = {};
        if (this.data.gtmEvt) dt.event = this.data.gtmEvt;
        if (this.data.gtmName) dt.feature_name = this.data.gtmName;
        if (this.data.gtmLoc) dt.feature_location = this.data.gtmLoc;
        if (this.data.gtmIdx) dt.feature_index = this.data.gtmIdx;
        if (this.data.gtmType) dt.feature_type = this.data.gtmType;
        if (this.data.gtmPremierName) dt.premier_name = this.data.gtmPremierName;
        if (this.data.gtmPremierPrice) dt.premier_price = this.data.gtmPremierPrice;
        if (this.data.gtmPremierId) dt.premier_id = this.data.gtmPremierId;

        window.dataLayer.push(dt);

        this.ahoy.sendEventClick();
      }
    }.bind(this));
  }
}
